import { TagColors } from "@certa/catalyst/components/Tag";
import { CatalystColors } from "@certa/catalyst/constants/styles";
import { Checkmark } from "@certa/icons/components/Checkmark";
import { Flag } from "@certa/icons/components/Flag";
import { Info } from "@certa/icons/components/Info";
import { Warning } from "@certa/icons/components/Warning";
import type { Badge, BadgeUIMode, BadgeUIType } from "@certa/types";
import { css, cx } from "emotion";
import type { BadgeDefinition } from "@certa/queries/types/instanceSettings.types";

const BADGE_TYPE_ICON_COLOR_MAPPING: Readonly<
  Record<
    BadgeUIType,
    {
      tagColor: TagColors;
      textColor: CatalystColors;
      iconColor: TagColors;
      icon: React.ReactElement;
    }
  >
> = {
  info: {
    tagColor: TagColors.TEAL,
    textColor: CatalystColors.TEAL_600,
    iconColor: TagColors.TEAL,
    icon: <Info autoSize />
  },
  warning: {
    tagColor: TagColors.ORANGE,
    iconColor: TagColors.ORANGE,
    textColor: CatalystColors.ORANGE_600,
    icon: <Warning autoSize />
  },
  error: {
    tagColor: TagColors.RED,
    iconColor: TagColors.RED,
    textColor: CatalystColors.RED_600,
    icon: <Info autoSize />
  },
  success: {
    tagColor: TagColors.GREEN,
    iconColor: TagColors.GREEN,
    textColor: CatalystColors.GREEN_600,
    icon: <Checkmark autoSize />
  }
};

export const computeBadgeIconAndColor = (
  badge: Badge | BadgeDefinition,
  {
    modeOverride
  }: {
    modeOverride: BadgeUIMode | undefined;
  }
) => {
  const badgeMode = modeOverride || badge.uiSpecs?.mode || "both";
  const badgeType = badge.uiSpecs?.type;
  const { icon: tagIcon, tagColor } = badgeType
    ? BADGE_TYPE_ICON_COLOR_MAPPING[badgeType]
    : {};

  const color = badge.uiSpecs?.color ?? tagColor ?? TagColors.NEUTRAL;
  const icon = badge.uiSpecs?.icon ? (
    <i
      className={cx(
        "material-icons",
        css({
          fontFamily: "Material Icons !important",
          color: "inherit",
          fontSize: "1rem",
          width: "1rem",
          height: "1rem"
        })
      )}
      aria-hidden={true}
    >
      {badge.uiSpecs.icon}
    </i>
  ) : (
    (tagIcon ?? <Flag />)
  );

  return {
    icon,
    color,
    badgeMode
  };
};
